import { NavigateFunction } from 'react-router-dom';
import { NavigateLink } from '@/components/navigate/NavigateLinks.tsx';

export const attendTrackPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [{ label: 'Inicio', onClick: () => navigate('/') }];

export const childrenAttendTrackPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...attendTrackPageBreadcrumbs(navigate),
  { label: 'Monitoreo de agendas', onClick: () => navigate('/attend-track') },
];
